const Page = [
  {
    title: "数据看板",
    key: "0",
    disabled: true,
    children: [
      // { title: "数据看板", key: "DailyMonitor" },
      { title: "管理看板", key: "BoardTotal" },
      {
        title: "工地巡查大屏",
        key: "Patrol",
        children: [
          { title: "取消样板工地", key: "Patrol-/api/worksite/model" },
          { title: "保存预置位", key: "Patrol-/api/worksite/camera/preset" },
          { title: "返回预设位", key: "Patrol-/api/worksite/camera/reset" },
          { title: "设备重启", key: "Patrol-/api/worksite/camera/restart" },
        ],
      },
      { title: "展厅数据看板", key: "ExhibitionBoard" }, //ExhibitionBoard
      { title: "展厅数据看板2", key: "ExhibitionBoard2" }, //ExhibitionBoard
      {
        title: "工地案场",
        key: "CaseField",
        children: [
          { title: "取消样板工地", key: "CaseField-/api/worksite/model" },
          { title: "保存预置位", key: "CaseField-/api/worksite/camera/preset" },
          { title: "返回预设位", key: "CaseField-/api/worksite/camera/reset" },
          { title: "设备重启", key: "CaseField-/api/worksite/camera/restart" },
        ],
      },
      {
        title: "展厅案场",
        key: "customPreview",
        children: [
          { title: "取消样板工地", key: "customPreview-/api/worksite/model" },
        ],
      }, //id名要和给后端的名字一样
      // { title: "AI可视化看板", key: "DataV" },
      { title: "旧版管理端看板", key: "DataV" },
      {
        title: "地图案场看板",
        key: "MapFieldboard",
      },
      {
        title: "直播案场",
        key: "VideoRecordView",
        children: [
          { title: "取消样板工地", key: "VideoRecordView-/api/worksite/model" },
        ],
      },
    ],
  },
  {
    title: "工地管理",
    key: "1",
    disabled: true,
    children: [
      // { title: "定制地图", key: "CustomMap" },
      {
        title: "工地列表",
        key: "SiteList",
        children: [
          { title: "新建工地", key: "SiteList-/api/worksite/addworksite" },
          { title: "导出", key: "SiteList-/api/worksite/workexport" },
          { title: "详情", key: "SiteList-/api/worksite/detail" },
          { title: "直播", key: "SiteList-/api/worksite/camera/video" },
          { title: "保存预置位", key: "SiteList-/api/worksite/camera/preset" },
          { title: "返回预设位", key: "SiteList-/api/worksite/camera/reset" },
          { title: "设备重启", key: "SiteList-/api/worksite/camera/restart" },
          // {
          //   title: "查看预置位历史记录",
          //   key: "SiteList-/api/worksite/camera/restart",
          // },
          { title: "快照", key: "SiteList-/api/worksite/snapshot" },
          { title: "回放", key: "SiteList-/api/worksite/playbackstart" },
          { title: "考勤", key: "SiteList-/api/worksite/attendance" },
          { title: "修改", key: "SiteList-/api/worksite/updateworksite" },
        ],
      },
      {
        title: "施工地图",
        key: "SiteMap",
        children: [
          { title: "工地详情", key: "SiteMap-/api/worksite/mapsitedetail" },
          { title: "快照", key: "SiteMap-/api/worksite/snapshot" },
          { title: "考勤", key: "SiteMap-/api/worksite/attendance" },
          { title: "回放", key: "SiteMap-/api/worksite/playbackstart" },
        ],
      },
      // { title: "暂停施工", key: "SiteSuspend" },
      {
        title: "日报管理",
        key: "DailyList",
        children: [{ title: "导出", key: "DailyList-/api/device/import" }],
      },
      {
        title: "样板工地管理",
        key: "SampleSite",
        children: [
          { title: "设置样板工地", key: "SampleSite-/api/worksite/model" },
          { title: "直播", key: "SampleSite-/api/worksite/camera/video" },
          // { title: "查看回放", key: "SampleSite-/api/worksite/playbackstart" },
        ],
      },
    ],
  },
  {
    title: "人员管理",
    key: "2",
    disabled: true,
    children: [
      {
        title: "人员考勤",
        key: "WorkerAttend",
        children: [
          // { title: "查看考勤统计", key: "WorkerAttend-/api/worksite/detail" },
          { title: "导出", key: "WorkerAttend-/api/worker/attendanceexport" },
          { title: "考勤日历", key: "WorkerAttend-/api/worker/calendar" },
        ],
      },
      {
        title: "人员列表",
        key: "WorkerList",
        children: [
          { title: "导出", key: "WorkerList-/api/worker/workerexport" },
        ],
      },
      // { title: "人员考勤统计", key: "WorkerAttendStatistics" },
    ],
  },
  {
    title: "工地形象",
    key: "3",
    disabled: true,
    children: [
      {
        title: "报警事件管理",
        key: "AlarmEvent",
        children: [
          // { title: "批量审核照片", key: "AlarmEvent-/api/snapshot/pickup" },
          { title: "导出", key: "AlarmEvent-/api/worker/eventexport" },
          { title: "直播", key: "AlarmEvent-/api/worksite/camera/video" },
          { title: "纠正", key: "AlarmEvent-/api/snapshot/pickup" },
        ],
      },
      {
        title: "整洁管理",
        key: "SiteNeat",
        children: [
          // { title: "批量审核照片", key: "SiteNeat-/api/snapshot/pickup" },
          { title: "导出", key: "SiteNeat-/api/worker/imageexport" },
          { title: "直播", key: "SiteNeat-/api/worksite/camera/video" },
          { title: "纠正", key: "SiteNeat-/api/snapshot/pickup" },
          // { title: "纠正", key: "SiteNeat-/api/snapshot/pickup" },
        ],
      },
      {
        title: "纠正日志",
        key: "CorrectionLog",
        children: [],
      },
    ],
  },
  {
    title: "数据统计",
    key: "4",
    disabled: true,
    children: [
      { title: "日报", key: "DailySheet" },
      {
        title: "考勤统计",
        key: "AttendStatistics",
        children: [
          {
            title: "按人员统计导出",
            key: "AttendStatistics-/api/count/acountworkerexport",
          },
          {
            title: "按工地统计导出",
            key: "AttendStatistics-/api/count/acountwsexport",
          },
          // { title: "查看详情", key: "AttendStatistics-" }, //跳到了人员考勤页面
        ],
      },
      {
        title: "工地形象统计",
        key: "SiteImage",
        children: [
          {
            title: "按组织统计导出",
            key: "SiteImage-/api/count/wscountbcexport",
          },
          {
            title: "按主要负责人统计导出",
            key: "SiteImage-/api/count/wscountbossexport",
          },
          ,
          {
            title: "按工地统计导出",
            key: "SiteImage-/api/count/wscountwsexport",
          },
        ],
      },
    ],
  },
  {
    title: "设备管理",
    key: "5",
    disabled: true,
    children: [
      {
        title: "设备列表",
        key: "DeviceList",
        children: [
          {
            title: "导出设备累计时长",
            key: "DeviceList-/api/device/deviceonoffexport",
          },
          { title: "设备分配", key: "DeviceList-/api/device/distribution" },
          { title: "导出", key: "DeviceList-/api/device/deviceexport" },
          { title: "直播", key: "DeviceList-/api/worksite/camera/video" },
          { title: "绑定记录", key: "DeviceList-/api/device/bindaction" },
        ],
      },
      {
        title: "设备库存",
        key: "DeviceStock",
        children: [
          { title: "导入设备账号表格", key: "DeviceStock-/api/device/import" },
          {
            title: "导入设备发货分配表格",
            key: "DeviceStock-/api/device/distributionimport",
          },
          { title: "设备分配", key: "DeviceStock-/api/device/distribution" },
        ],
      },
      {
        title: "设备统计",
        key: "DeviceStatistics",
        children: [
          {
            title: "按组织统计导出",
            key: "DeviceStatistics-/api/count/dcountbcexport",
          },
          {
            title: "按负责人统计导出",
            key: "DeviceStatistics-/api/count/dcountwbossexport",
          },
          {
            title: "按组织统计历史分析",
            key: "DeviceStatistics-/api/count/dcountbchistory",
          },
          {
            title: "按负责人统计历史分析",
            key: "DeviceStatistics-/api/count/dcountwbosshistory",
          },
        ],
      },
    ],
  },

  {
    title: "权限管理",
    key: "6",
    disabled: true,
    children: [
      // { title: "角色权限", key: "RoleList" },
      {
        title: "用户权限",
        key: "UserList",
        children: [
          { title: "添加用户", key: "UserList-/api/user/adduser" },
          { title: "查看", key: "UserList-/api/user/userdetails" },
          { title: "编辑", key: "UserList-/api/user/edituser" },
          { title: "删除", key: "UserList-/api/user/deluser" },
        ],
      },
      {
        title: "角色管理",
        key: "RoleList",
        children: [
          { title: "添加用户", key: "RoleList-/api/role/addrole" },
          { title: "查看", key: "RoleList-/api/role/details" },
          { title: "编辑", key: "RoleList-/api/role/editrole" },
          { title: "删除", key: "RoleList-/api/role/delrole" },
        ],
      },
      {
        title: "组织管理",
        key: "Organization",
        children: [
          {
            title: "添加子集",
            key: "Organization-/api/companystore/addcompanystore",
          },
          {
            title: "编辑",
            key: "Organization-/api/companystore/updatecompanystore",
          },
          {
            title: "删除",
            key: "Organization-/api/companystore/deletecompanystore",
          },
        ],
      },
      {
        title: "个性化设置",
        key: "PersonalizedView",
        children: [
          { title: "编辑", key: "PersonalizedView-/api/setSelf/update" },
          {
            title: "查看修改记录",
            key: "PersonalizedView-/api/userLog/selectByUlBase",
          },
        ],
      },
    ],
  },

  // {
  //   title: "库存与订单",
  //   key: "7",
  //   disabled: true,
  //   children: [{ title: "库存管理", key: "DeviceStockList" }],
  // },
];

export default Page;
